<template>
  <router-link
    class="logo-container"
    :class="[`text-${color}`, { horizontal }]"
    :to="{ name: 'Home' }"
  >
    <img :src="logoUrl" />
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    color: {
      type: String,
      default: 'black',
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoUrl () {
      if (this.small) {
        if (this.color === 'white') return '/img/images/logo_white.png'
        return '/img/images/logo_black.png'
      }

      if (this.color === 'white') return '/img/images/LendingWell_Logo_White.png'
      return '/img/images/LendingWell_Logo_Black.png'
    },
  },
}
</script>

<style lang="scss" scoped>
.logo-container {
  height: 100%;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  background-color: transparent !important;

  &.text-white { color: white; }
  font-size: 32px;
  text-decoration: none;

  img {
    margin-right: 20px;
    width: auto;
    height: 46px;

    flex-shrink: 0;
  }

  &.horizontal {
    width: 100%;
    height: auto;

    img {
      width: 100%;
      height: auto;
    }
  }
}

</style>
